import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useQueryClient } from '@tanstack/react-query'
import { authUserQueryKey } from '$api-client/@tanstack/react-query.gen'
import { RoutePath } from 'src/enums/routing'
import { AuthRoutePath } from '../routes/public'

export function OAuthCallbackPage() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  useEffect(() => {
    const success = searchParams.get('success')

    // OAuth success - refresh user data and redirect to dashboard
    if (success === 'true') {
      queryClient.invalidateQueries({ queryKey: authUserQueryKey() })
      return navigate(RoutePath.Root, { replace: true })
    }

    navigate(AuthRoutePath.Login, { replace: true })
  }, [searchParams, navigate, queryClient])

  return null
}
